import { useAuth } from "@/auth/AuthContext";
import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { HIT_TARGET_MIN } from "@/ui/components/listRowA11y";
import { Platform, Text, View } from "react-native";

const actionStyle = { alignSelf: "stretch" as const, minHeight: HIT_TARGET_MIN };

/**
 * Fallback der App-Shell-Boundary. Die Finder-Sperre hat eine eigene Boundary.
 */
export function RootCrashFallback({ resetError }: { resetError: () => void }) {
  const { theme } = useTheme();
  const { signOut } = useAuth();

  const reload = () => {
    const loc = globalThis.location as { reload?: () => void } | undefined;
    if (typeof loc?.reload === "function") {
      loc.reload();
      return;
    }
    resetError();
  };

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        padding: theme.space.lg,
        backgroundColor: theme.color.bg,
      }}
      {...(Platform.OS === "web" ? { dataSet: { fcShell: "1" } } : {})}
    >
      <View
        style={{
          maxWidth: theme.layout.readable,
          width: "100%",
          alignSelf: "center",
          gap: theme.space.md,
        }}
      >
        <Text
          accessibilityRole="header"
          style={{
            color: theme.color.dangerText,
            fontSize: theme.fontSize.title,
            fontWeight: "700",
          }}
        >
          Etwas ist schiefgelaufen.
        </Text>
        <AppButton
          variant="outline"
          accessibilityRole="button"
          style={actionStyle}
          onPress={() => {
            void Promise.resolve(signOut()).catch((error: unknown) => {
              console.error(
                "Abmelden fehlgeschlagen",
                error instanceof Error ? error.message : error,
              );
            });
          }}
        >
          Abmelden
        </AppButton>
        <AppButton accessibilityRole="button" style={actionStyle} onPress={reload}>
          Neu laden
        </AppButton>
      </View>
    </View>
  );
}
